import Client from "../AxiosClient";
const login = "/public/auth/login";
const logout = "/private/accounts/logout";
const getapp = "/public/auth/getapp";

export default {
  async login(userInfo) {
    let response = await Client.post(`${login}`, userInfo);
    console.log(response);
    return response;
  },

  async logout(user) {
    const response = await Client.post(`${logout}`, user);
    return response;
  },
  async getapp() {
    const response = await Client.get(`${getapp}`);
    return response;
  },
};
